import { Listbox, Transition } from "@headlessui/react";
import React, { Fragment, useEffect, useState } from "react";
import SVGIcon from "../SVGIcon";
import { usePathname } from "../../navigation";
import Link from "next/link";
import useTracking from "../Hooks/useTracking";

const SupportSidebarMenuMobile = ({ navigation }) => {
  const { navigate } = useTracking();
  const pathname = usePathname() ?? "";
  const [isOpen, setIsOpen] = useState(false);
  const [selected, setSelected] = useState(
    navigation.find((link) => pathname === link.path)
  );
  useEffect(() => {
    let selected = navigation.find((link) => pathname === link.path);
    // console.log("selected", selected);
    if (!selected) {
      selected = navigation.find((link) => link.link === "terms-conditions");
      // console.log("selected 2", selected);
    }
    setSelected(selected);
  }, [pathname]);

  return (
    <div className="container my-4">
      <Listbox value={selected} onChange={setSelected}>
        <div className="relative mt-1">
          <Listbox.Button
            className="w-full active:ring-0 !justify-start btn btn--white !rounded focus:outline-none focus-visible:border-primary-500 focus-visible:ring-2 focus-visible:ring-white/75 focus-visible:ring-offset-0 sm:text-sm border border-tertiary-100 dark:border-tertiary-400"
            onClick={() => setIsOpen(!isOpen)}
          >
            <span className="flex items-center gap-2 truncate text-tertiary dark:text-white">
              {selected && (
                <>
                  {/* <SVGIcon icon={selected.icon} className="w-5 h-5" /> */}
                  {selected?.title}
                </>
              )}
            </span>
            <span className="absolute inset-y-0 flex items-center right-4">
              <SVGIcon
                icon="angleArrow"
                className="w-3 h-3 rotate-90 opacity-50 text-tertiary dark:text-white"
              />
            </span>
          </Listbox.Button>
          <Transition
            as={Fragment}
            show={isOpen}
            leave="transition ease-in duration-100"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Listbox.Options className="absolute z-10 w-full p-1 mt-1 overflow-auto text-base bg-white rounded shadow-lg dark:bg-tertiary-800 max-h-fit ring-1 ring-black/5 focus:outline-none sm:text-sm">
              {navigation.map((link, i) => (
                <Listbox.Option
                  key={i}
                  className={({ active }) =>
                    `relative cursor-default select-none py-2 px-4 font-bold ${active} ${
                      active
                        ? "bg-tertiary-500 text-white dark:bg-tertiary-500"
                        : "text-tertiary/50 dark:text-white/50"
                    }`
                  }
                  value={link}
                >
                  {({ selected, active }) => (
                    <Link
                      href={link.path}
                      className="flex items-center gap-2"
                      onClick={() => {
                        setIsOpen(false);
                        navigate(link.path, {
                          component: "SupportSidebarMenu",
                          label: link.title,
                          isMobileOrTablet: "Yes",
                        });
                      }}
                    >
                      {/* <SVGIcon icon={link.icon} className="w-4 h-4 font-bold" /> */}
                      <span className={`block truncate font-bold`}>
                        {link.title}
                      </span>
                    </Link>
                  )}
                </Listbox.Option>
              ))}
            </Listbox.Options>
          </Transition>
        </div>
      </Listbox>
    </div>
  );
};

export default SupportSidebarMenuMobile;
